import React from "react";
import tw from "tailwind.macro";
import styled from "styled-components";
import { scrollToSection } from "utils/scrollTo";

const Cta = styled.button`
  ${tw`inline-block my-2 p-0 text-lg text-center uppercase leading-tight font-normal font-trade-gothic-20 text-center`}
  ${({ primary }) =>
    primary
      ? `
      border-width: 3px;
      padding-top: 0.725rem;
      padding-right: 1.25rem;
      padding-bottom: 0.4rem;
      padding-left: 1.25rem;
    `
      : `
      border-bottom-width: 3px;
    `}
  ${({ variant }) =>
    variant === "light"
      ? tw`text-white border-white`
      : tw`text-action-blue border-action-blue`}
`;

const CallToAction = ({
  scrollTo,
  href,
  text,
  primary,
  variant,
  target,
  onClick,
}) => (
  <div className="flex items-center justify-center">
    {scrollTo || typeof onClick === "function" ? (
      <Cta
        onClick={(e) => (scrollTo ? scrollToSection(scrollTo) : onClick(e))}
        primary={primary}
        variant={variant}
      >
        {text}
      </Cta>
    ) : (
      <Cta
        as="a"
        primary={primary}
        variant={variant}
        rel="prefetch"
        target={target || "_self"}
        href={href}
      >
        {text}
      </Cta>
    )}
  </div>
);

export default CallToAction;
